import script from "./AdminProductTypeDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductTypeDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductTypeDetailsPage.vue?vue&type=style&index=0&id=a2cf3c3c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2cf3c3c"]])

export default __exports__